export enum PerlegoIntegrationMode {
  STANDARD = 'standard',
  MINIMAL = 'minimal',
  OFF = 'off',
}
